import { React } from "react"
import SidebarDashboardSupervisor from "../../components/sidebars/SidebarDashboardSupervisor"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"

export default function OrderedReports() {
  return (
    <>
      <PageSidebarContent>
        <SidebarDashboardSupervisor />
      </PageSidebarContent>
      <div className="my-dashboard-wrapper">
        <h1>Ordered Reports</h1>
      </div>
    </>
  )
}
